<template>
  <div >
    <p style="font-size:20px;color:green">用户名：{{certName}}</p>
    <p style="font-size:20px;color:green">身份证号：{{certNo}}</p>
    <p style="font-size:20px;color:green">结果：{{retData}}</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      retData:`${this.$route.query.retData}`,
      certName:`${this.$route.query.certName}`,
      certNo:`${this.$route.query.certNo}`
    }
  },

};
</script>

<style>
</style>